module.exports = __webpack_public_path__ + "img/26_76.958ef856.png";